import { render, staticRenderFns } from "./recordDetails.vue?vue&type=template&id=7a40f64a&scoped=true&"
import script from "./recordDetails.vue?vue&type=script&lang=js&"
export * from "./recordDetails.vue?vue&type=script&lang=js&"
import style0 from "./recordDetails.vue?vue&type=style&index=0&id=7a40f64a&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a40f64a",
  null
  
)

export default component.exports